export { default as Img200 } from './processed/200/aaatenBC.jpg';
export { default as Img400 } from './processed/400/aaatenBC.jpg';
export { default as Imgthumb } from './processed/thumb/aaatenBC.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/aaatenBC.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/aaatenBC.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      188,
      153,
      96
    ],
    "_population": 2479,
    "_hsl": [
      0.10326086956521736,
      0.4070796460176992,
      0.5568627450980392
    ]
  },
  "LightVibrant": {
    "_rgb": [
      231,
      198,
      135
    ],
    "_population": 590,
    "_hsl": [
      0.109375,
      0.6666666666666665,
      0.7176470588235294
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      89,
      55,
      31
    ],
    "_population": 3028,
    "_hsl": [
      0.06896551724137932,
      0.4833333333333333,
      0.23529411764705882
    ]
  },
  "Muted": {
    "_rgb": [
      118,
      150,
      108
    ],
    "_population": 2409,
    "_hsl": [
      0.29365079365079366,
      0.1666666666666667,
      0.5058823529411764
    ]
  },
  "LightMuted": {
    "_rgb": [
      200,
      203,
      164
    ],
    "_population": 1989,
    "_hsl": [
      0.17948717948717943,
      0.2727272727272725,
      0.7196078431372549
    ]
  },
  "DarkMuted": {
    "_rgb": [
      66,
      53,
      38
    ],
    "_population": 308,
    "_hsl": [
      0.08928571428571429,
      0.2692307692307693,
      0.20392156862745098
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/aaatenBC.js